import React, { useMemo } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "./App.css";
import Home from "./Route/Home";
import Login from "./Route/Login";
import Sso from "./Route/Sso";
import { createAppTheme } from "./styles/theme";
import { getTenantColors } from "./styles/utils/colors";

function App() {
  // 테넌트별 색상 가져오기
  const tenantColors = useMemo(() => getTenantColors(), []);
  
  // 테넌트별 테마 생성
  const theme = useMemo(() => createAppTheme(tenantColors), [tenantColors]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
    <div className="App" style={{ height: "100%" }}>
      <BrowserRouter>
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/home" element={<Home />} />
            <Route path="/sso" element={<Sso />} />
        </Routes>
      </BrowserRouter>
    </div>
    </ThemeProvider>
  );
}

export default App;
